import { createSlice } from "@reduxjs/toolkit";

const initial_state = {
  users: [],
  selectedUser: null,
  loading: false,
  isError: false,
  errorMessage: "",
  totalUsers: 0,
  currentPage: 1,
  totalPages: 1,
  filters: {
    search: "",
    status: "all", // all, active, blocked, pending
    role: "all",
    dateRange: null,
  },
  sortBy: "createdAt",
  sortOrder: "desc",
  userActivity: [],
  selectedUserActivity: [],
  bulkActions: {
    selectedUsers: [],
    isSelectAll: false,
  },
};

const adminUserManagementSlice = createSlice({
  name: "ADMIN_USER_MANAGEMENT",
  initialState: initial_state,
  reducers: {
    updateAdminUserManagement: (state, { payload }) => {
      return { ...state, ...payload };
    },
    setUsers: (state, { payload }) => {
      state.users = payload.users || payload.data || payload;
      state.totalUsers = payload.totalUsers || 0;
      state.totalPages = payload.totalPages || 1;
      state.currentPage = payload.currentPage || 1;
    },
    setSelectedUser: (state, { payload }) => {
      state.selectedUser = payload;
    },
    setLoading: (state, { payload }) => {
      state.loading = payload;
    },
    setError: (state, { payload }) => {
      state.isError = true;
      state.errorMessage = payload;
    },
    clearError: (state) => {
      state.isError = false;
      state.errorMessage = "";
    },
    setFilters: (state, { payload }) => {
      state.filters = { ...state.filters, ...payload };
      state.currentPage = 1; // Reset to first page when filters change
    },
    setSorting: (state, { payload }) => {
      state.sortBy = payload.sortBy;
      state.sortOrder = payload.sortOrder;
    },
    setPagination: (state, { payload }) => {
      state.currentPage = payload.page;
    },
    updateUser: (state, { payload }) => {
      const index = state.users.findIndex(user => user.id === payload.id);
      if (index !== -1) {
        state.users[index] = { ...state.users[index], ...payload };
      }
      if (state.selectedUser && state.selectedUser.id === payload.id) {
        state.selectedUser = { ...state.selectedUser, ...payload };
      }
    },
    deleteUser: (state, { payload }) => {
      state.users = state.users.filter(user => user.id !== payload);
      if (state.selectedUser && state.selectedUser.id === payload) {
        state.selectedUser = null;
      }
    },
    setUserActivity: (state, { payload }) => {
      state.userActivity = payload;
    },
    setSelectedUserActivity: (state, { payload }) => {
      state.selectedUserActivity = payload;
    },
    // Bulk actions
    toggleUserSelection: (state, { payload }) => {
      const userId = payload;
      const isSelected = state.bulkActions.selectedUsers.includes(userId);
      if (isSelected) {
        state.bulkActions.selectedUsers = state.bulkActions.selectedUsers.filter(id => id !== userId);
      } else {
        state.bulkActions.selectedUsers.push(userId);
      }
    },
    selectAllUsers: (state) => {
      state.bulkActions.isSelectAll = true;
      state.bulkActions.selectedUsers = state.users.map(user => user.id);
    },
    clearUserSelection: (state) => {
      state.bulkActions.isSelectAll = false;
      state.bulkActions.selectedUsers = [];
    },
    bulkUpdateUsers: (state, { payload }) => {
      const { userIds, updates } = payload;
      state.users = state.users.map(user => 
        userIds.includes(user.id) ? { ...user, ...updates } : user
      );
      state.bulkActions.selectedUsers = [];
      state.bulkActions.isSelectAll = false;
    },
    bulkDeleteUsers: (state, { payload }) => {
      const userIds = payload;
      state.users = state.users.filter(user => !userIds.includes(user.id));
      state.bulkActions.selectedUsers = [];
      state.bulkActions.isSelectAll = false;
    },
  },
});

export const {
  updateAdminUserManagement,
  setUsers,
  setSelectedUser,
  setLoading,
  setError,
  clearError,
  setFilters,
  setSorting,
  setPagination,
  updateUser,
  deleteUser,
  setUserActivity,
  setSelectedUserActivity,
  toggleUserSelection,
  selectAllUsers,
  clearUserSelection,
  bulkUpdateUsers,
  bulkDeleteUsers,
} = adminUserManagementSlice.actions;
export default adminUserManagementSlice.reducer;
